// Work-in-progress (WIP) statement row ids for analysis metrics. The `wip` analysis source is built
// from an account's WIP statements (see ./wipSource), which expose these two values directly rather
// than as a statement matrix, so the ids are plain literals matching the WIP DTO field names.
export const WIP = {
	projectBacklogCost: "projectBacklogCost",
	projectBacklogGrossProfit: "projectBacklogGrossProfit",
} as const;
